// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"96e6d0d3","85":"941b21c9","151":"c24b158e","360":"a2b368e2","453":"ace21015","598":"9509f7ac","635":"b76d25cb","903":"72e41a1b","967":"997f5504"}[chunkId] + ".chunk.js";
};